var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0265 3.78657L4.83984 9.38657C4.20049 9.94204 3.67881 10.6199 3.30555 11.3801C2.93229 12.1404 2.715 12.9677 2.6665 13.8132L2.6665 23.6932C2.66826 25.1827 3.2598 26.6108 4.31174 27.6652C5.36369 28.7197 6.79041 29.3146 8.27984 29.3199H23.7198C25.2072 29.3153 26.6323 28.7225 27.684 27.6707C28.7357 26.619 29.3286 25.1939 29.3332 23.7066V13.9999C29.2828 13.1067 29.0428 12.2344 28.6289 11.4413C28.2151 10.6481 27.637 9.95217 26.9332 9.39991L18.6932 3.62257C17.6912 2.98514 16.5221 2.66035 15.3349 2.68955C14.1476 2.71876 12.996 3.10064 12.0265 3.78657V3.78657Z",
    stroke: "#A5A7B8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 23.9866V19.9866",
    stroke: "#A5A7B8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.58e34a10.svg";
export { ForwardRef as ReactComponent };